/**
 * Stylizes a modifier option's pricing. See modifierHierarchyHelper
 */
export function OptionPriceFilter() {
    var getOptionPrice = function(option) {
        var stylizedPrice = '';

        if (option.price && option.price !== 0) {
            if (option.price > 0) {
                stylizedPrice += '+';
            } else {
                stylizedPrice += '-';
            }

            stylizedPrice += '$' + Math.abs(option.price).toFixed(2);
        }

        return stylizedPrice;
    };

    return getOptionPrice;
}
